import React, { useMemo, useRef, useState } from "react";

const plans = [
  {
    key: "free",
    nameAr: "الخطة المجانية",
    nameEn: "Free Plan",
    priceAr: "مجانًا",
    priceEn: "Free",
    scansAr: "7 عمليات مجانية مدى الحياة",
    scansEn: "7 free lifetime scans",
    validityAr: "",
    validityEn: "",
    badgeAr: "",
    badgeEn: "",
    featured: false,
    comingSoon: false,
    featuresAr: [
      "فحص الروابط و QR Codes",
      "تحديد مستوى الأمان (آمن – مشبوه – خطير)",
      "تنبيهات فورية عند وجود خطر",
      "توعية أمنية أساسية",
    ],
    featuresEn: [
      "Scan links and QR codes",
      "Security level detection (Safe – Suspicious – Dangerous)",
      "Instant alerts when a risk is detected",
      "Basic security awareness",
    ],
  },
  {
    key: "basic",
    nameAr: "Basic Plan",
    nameEn: "Basic Plan",
    priceAr: "120 جنيه",
    priceEn: "EGP 120",
    scansAr: "60 عملية",
    scansEn: "60 scans",
    validityAr: "الصلاحية: شهر",
    validityEn: "Validity: 1 month",
    badgeAr: "",
    badgeEn: "",
    featured: false,
    comingSoon: false,
    featuresAr: [
      "فحص الروابط و QR Codes",
      "تحديد مستوى الأمان (آمن – مشبوه – خطير – تصيد)",
      "توعية ذكية حسب نوع التهديد",
      "عرض Screenshot للينك قبل فتحه",
    ],
    featuresEn: [
      "Scan links and QR codes",
      "Security level detection (Safe – Suspicious – Dangerous – Phishing)",
      "Smart awareness based on threat type",
      "Preview screenshot before opening the link",
    ],
  },
  {
    key: "plus",
    nameAr: "Plus Plan",
    nameEn: "Plus Plan",
    priceAr: "180 جنيه",
    priceEn: "EGP 180",
    scansAr: "120 عملية",
    scansEn: "120 scans",
    validityAr: "الصلاحية: شهر",
    validityEn: "Validity: 1 month",
    badgeAr: "الأكثر استخدامًا",
    badgeEn: "Most Popular",
    featured: true,
    comingSoon: false,
    featuresAr: [
      "فحص الروابط و QR Codes",
      "تحديد مستوى الأمان (آمن – مشبوه – خطير – تصيد)",
      "توعية ذكية حسب نوع التهديد",
      "عرض Screenshot قبل فتح الرابط",
      "Chrome Extension للفحص التلقائي",
      "تحذير فوري قبل فتح أي لينك",
      "تقارير مبسطة لكل عملية",
    ],
    featuresEn: [
      "Scan links and QR codes",
      "Security level detection (Safe – Suspicious – Dangerous – Phishing)",
      "Smart awareness based on threat type",
      "Preview screenshot before opening the link",
      "Chrome Extension for automatic scanning",
      "Instant warning before opening any link",
      "Simple report for each scan",
    ],
  },
  {
    key: "pro",
    nameAr: "Pro Plan",
    nameEn: "Pro Plan",
    priceAr: "260 جنيه",
    priceEn: "EGP 260",
    scansAr: "200 عملية",
    scansEn: "200 scans",
    validityAr: "الصلاحية: شهر",
    validityEn: "Validity: 1 month",
    badgeAr: "",
    badgeEn: "",
    featured: false,
    comingSoon: false,
    featuresAr: [
      "فحص الروابط و QR Codes",
      "تحديد مستوى الأمان (آمن – مشبوه – خطير – تصيد)",
      "توعية ذكية حسب نوع التهديد",
      "عرض Screenshot قبل فتح الرابط",
      "Chrome Extension للفحص التلقائي",
      "تحذير فوري قبل فتح أي لينك",
      "تقارير تفصيلية لكل عملية",
      "دعم فني سريع 24/7",
      "أولوية في تنفيذ عمليات الفحص",
    ],
    featuresEn: [
      "Scan links and QR codes",
      "Security level detection (Safe – Suspicious – Dangerous – Phishing)",
      "Smart awareness based on threat type",
      "Preview screenshot before opening the link",
      "Chrome Extension for automatic scanning",
      "Instant warning before opening any link",
      "Detailed report for each scan",
      "Fast 24/7 support",
      "Priority scan processing",
    ],
  },
  {
    key: "family",
    nameAr: "Family Plan",
    nameEn: "Family Plan",
    priceAr: "400 جنيه",
    priceEn: "EGP 400",
    scansAr: "300 عملية",
    scansEn: "300 scans",
    validityAr: "الصلاحية: شهر",
    validityEn: "Validity: 1 month",
    badgeAr: "قريبًا",
    badgeEn: "Coming Soon",
    featured: false,
    comingSoon: true,
    extraAr: "حتى 4 أفراد",
    extraEn: "Up to 4 members",
    featuresAr: [
      "فحص الروابط و QR Codes",
      "تحديد مستوى الأمان (آمن – مشبوه – خطير – تصيد)",
      "توعية ذكية حسب نوع التهديد",
      "عرض Screenshot قبل فتح الرابط",
      "Chrome Extension للفحص التلقائي",
      "تحذير فوري قبل فتح أي لينك",
      "تقارير تفصيلية لكل عملية",
      "دعم فني",
      "لوحة تحكم لإدارة استخدام أفراد العائلة",
    ],
    featuresEn: [
      "Scan links and QR codes",
      "Security level detection (Safe – Suspicious – Dangerous – Phishing)",
      "Smart awareness based on threat type",
      "Preview screenshot before opening the link",
      "Chrome Extension for automatic scanning",
      "Instant warning before opening any link",
      "Detailed report for each scan",
      "Support included",
      "Dashboard to manage family usage",
    ],
  },
];

export default function PricingSection({ lang, onDownload }) {
  const isAr = lang === "ar";
  const sliderRef = useRef(null);
  const [activeLegalTab, setActiveLegalTab] = useState("refund");

  const refundContent = useMemo(
    () => ({
      title: isAr ? "سياسة الاسترجاع" : "Refund Policy",
      intro: isAr
        ? "نحرص في Aman-QO على تقديم خدمة موثوقة وآمنة."
        : "At Aman-QO, we aim to provide a reliable and secure service.",
      sections: [
        {
          heading: isAr ? "شروط الاسترجاع" : "Refund Conditions",
          items: [
            isAr
              ? "يمكن طلب استرجاع خلال 3 أيام من تاريخ الشراء."
              : "Refund requests can be made within 3 days of purchase.",
            isAr
              ? "يتم خصم تكلفة عمليات الفحص التي تم استخدامها قبل الاسترجاع."
              : "Used scans are deducted before processing the refund.",
            isAr
              ? "يتم احتساب تكلفة العملية بسعر أعلى لكل عملية فحص بنسبة 25%."
              : "Each used scan is recalculated at a 25% higher per-scan rate.",
            isAr
              ? "في حالة استهلاك أكثر من 30% من الباقة، لا يحق طلب استرجاع."
              : "No refund is allowed if more than 30% of the plan has been used.",
          ],
        },
        {
          heading: isAr ? "حالات لا يتم فيها الاسترجاع" : "Non-refundable Cases",
          items: [
            isAr
              ? "استهلاك أكثر من 30% من الباقة."
              : "More than 30% of the plan has been consumed.",
            isAr ? "إساءة استخدام الخدمة." : "Abuse or misuse of the service.",
            isAr
              ? "محاولة التحايل أو الاستغلال."
              : "Attempts of fraud, exploitation, or abuse.",
          ],
        },
        {
          heading: isAr ? "طريقة طلب الاسترجاع" : "How to Request a Refund",
          items: [
            isAr
              ? "التواصل عبر البريد الإلكتروني: amanqo.hq@gmail.com"
              : "Contact by email: amanqo.hq@gmail.com",
            isAr
              ? "إرسال بيانات الحساب وسبب الطلب."
              : "Send account details and the reason for the request.",
            isAr
              ? "يتم مراجعة الطلب خلال 5 إلى 7 أيام عمل."
              : "Requests are reviewed within 5 to 7 business days.",
          ],
        },
      ],
      cta: isAr ? "طلب استرجاع" : "Request Refund",
    }),
    [isAr],
  );

  const termsContent = useMemo(
    () => ({
      title: isAr ? "الشروط والأحكام" : "Terms & Conditions",
      intro: isAr
        ? "باستخدامك لمنصة Aman-QO، فإنك توافق على ما يلي:"
        : "By using Aman-QO, you agree to the following:",
      sections: [
        {
          heading: isAr ? "أحكام الاستخدام" : "Usage Terms",
          items: [
            isAr
              ? "الخدمة مخصصة لفحص الروابط و QR Codes قبل الدخول عليها."
              : "The service is intended to scan links and QR codes before opening them.",
            isAr
              ? "النتائج تساعد في اتخاذ القرار لكنها لا تمنع كل المخاطر بنسبة 100%."
              : "Results support decision-making but do not eliminate all risks 100%.",
            isAr
              ? "المستخدم مسؤول عن قراراته بعد الفحص."
              : "The user remains responsible for decisions made after scanning.",
            isAr
              ? "يُمنع استخدام المنصة في أي نشاط غير قانوني."
              : "The platform must not be used for any illegal activity.",
            isAr
              ? "يحق للمنصة تعديل الأسعار أو الخدمات أو السياسات في أي وقت."
              : "The platform may update prices, services, or policies at any time.",
          ],
        },
      ],
      cta: isAr ? "اشترك الآن" : "Subscribe Now",
    }),
    [isAr],
  );

  const activeLegal = activeLegalTab === "refund" ? refundContent : termsContent;

  const scrollSlider = (direction) => {
    if (!sliderRef.current) return;
    const firstCard = sliderRef.current.querySelector(".aq-plan-card");
    const gap = 18;
    const amount = (firstCard?.clientWidth || 340) + gap;

    sliderRef.current.scrollBy({
      left: direction === "next" ? amount : -amount,
      behavior: "smooth",
    });
  };

  return (
    <section className="aq-section aq-pricing-section" id="pricing">
      <div className="aq-container">
        <div className="aq-section-head aq-pricing-head">
          <span className="aq-pricing-kicker">
            {isAr ? "الخطط والأسعار" : "Plans & Pricing"}
          </span>

          <h2 className="aq-headline">
            {isAr ? "اختر الخطة المناسبة لك" : "Choose the right plan for you"}
          </h2>

          <p className="aq-muted aq-pricing-sub">
            {isAr
              ? "باقات مرنة تناسب الأفراد والمستخدمين المتقدمين، مع حماية عملية للروابط و QR Codes وتنبيهات ذكية قبل الخطر."
              : "Flexible plans for individuals and advanced users, with smart link and QR protection, clear risk detection, and practical alerts before danger."}
          </p>
        </div>

        <div className="aq-pricing-slider-wrap">
          <button
            type="button"
            className="aq-pricing-nav aq-pricing-nav-prev"
            onClick={() => scrollSlider("prev")}
            aria-label={isAr ? "السابق" : "Previous"}
          >
            ‹
          </button>

          <div className="aq-pricing-slider" ref={sliderRef}>
            {plans.map((plan) => (
              <article
                key={plan.key}
                className={`aq-plan-card ${plan.featured ? "is-featured" : ""} ${plan.comingSoon ? "is-soon" : ""}`}
              >
                <div className="aq-plan-top">
                  <div className="aq-plan-badges">
                    {plan.badgeAr || plan.badgeEn ? (
                      <span
                        className={`aq-plan-badge ${plan.featured ? "is-hot" : ""} ${plan.comingSoon ? "is-soon" : ""}`}
                      >
                        {isAr ? plan.badgeAr : plan.badgeEn}
                      </span>
                    ) : null}
                  </div>

                  <h3 className="aq-plan-name">
                    {isAr ? plan.nameAr : plan.nameEn}
                  </h3>

                  <div className="aq-plan-price">
                    {isAr ? plan.priceAr : plan.priceEn}
                  </div>

                  <div className="aq-plan-meta">
                    <span>{isAr ? plan.scansAr : plan.scansEn}</span>
                    {(isAr ? plan.validityAr : plan.validityEn) ? (
                      <span>{isAr ? plan.validityAr : plan.validityEn}</span>
                    ) : null}
                    {plan.extraAr || plan.extraEn ? (
                      <span>{isAr ? plan.extraAr : plan.extraEn}</span>
                    ) : null}
                  </div>
                </div>

                <ul className="aq-plan-features">
                  {(isAr ? plan.featuresAr : plan.featuresEn).map((feature, idx) => (
                    <li key={`${plan.key}-${idx}`}>{feature}</li>
                  ))}
                </ul>

                <div className="aq-plan-footer">
                  <button
                    className={`aq-btn ${plan.featured ? "aq-btn-solid" : "aq-btn-ghost"} aq-plan-btn`}
                    onClick={onDownload}
                    disabled={plan.comingSoon}
                  >
                    {plan.comingSoon
                      ? isAr
                        ? "قريبًا"
                        : "Coming Soon"
                      : isAr
                        ? "ابدأ الآن"
                        : "Get Started"}
                  </button>

                  {plan.featured && (
                    <p className="aq-plan-note">
                      {isAr
                        ? "أفضل اختيار لمعظم المستخدمين"
                        : "Best fit for most users"}
                    </p>
                  )}
                </div>
              </article>
            ))}
          </div>

          <button
            type="button"
            className="aq-pricing-nav aq-pricing-nav-next"
            onClick={() => scrollSlider("next")}
            aria-label={isAr ? "التالي" : "Next"}
          >
            ›
          </button>
        </div>

        <div className="aq-pricing-stack">
          <div className="aq-extension-hero">
            <div className="aq-extension-hero-copy">
              <span className="aq-extension-chip">Chrome Extension</span>

              <h3>
                {isAr
                  ? "الفحص التلقائي أثناء التصفح"
                  : "Automatic scanning while browsing"}
              </h3>

              <p className="aq-muted">
                {isAr
                  ? "مع إضافة Chrome، مش محتاج تفتح التطبيق نهائيًا. أي لينك بتضغط عليه بيتفحص تلقائيًا قبل ما يفتح، مع تحذير واضح لو فيه خطر."
                  : "With the Chrome extension, you do not need to open the app every time. Any link you click is scanned automatically before it opens, with a clear warning if risk is detected."}
              </p>

              <div className="aq-extension-points">
                <span>WhatsApp Web</span>
                <span>Instagram</span>
                <span>Messenger</span>
                <span>{isAr ? "أي موقع داخل المتصفح" : "Any website in the browser"}</span>
              </div>
            </div>

            <div className="aq-extension-hero-side">
              <h4>{isAr ? "المميزات" : "Features"}</h4>

              <ul className="aq-plan-features aq-plan-features--compact">
                <li>
                  {isAr
                    ? "فحص فوري لأي رابط بمجرد الضغط عليه"
                    : "Instant scan for any clicked link"}
                </li>
                <li>
                  {isAr
                    ? "تحذير يظهر قبل فتح اللينك لو فيه خطر"
                    : "Warning shown before opening a risky link"}
                </li>
                <li>
                  {isAr
                    ? "حماية مستمرة أثناء التصفح بدون تدخل منك"
                    : "Continuous protection while browsing with no manual action"}
                </li>
                <li>
                  {isAr
                    ? "عرض نتيجة الفحص مباشرة قبل الدخول"
                    : "Scan result shown before entering the page"}
                </li>
              </ul>

              <button
                className="aq-btn aq-btn-solid aq-plan-btn aq-extension-btn"
                onClick={onDownload}
              >
                {isAr ? "جرّب الميزة" : "Try the feature"}
              </button>
            </div>
          </div>

          <div className="aq-legal-shell">
            <div className="aq-legal-card aq-legal-card--clean">
              <div className="aq-legal-header">
                <div>
                  <span className="aq-legal-kicker">
                    {isAr ? "السياسات" : "Policies"}
                  </span>
                  <h3>{activeLegal.title}</h3>
                  <p className="aq-muted">{activeLegal.intro}</p>
                </div>

                <div className="aq-legal-tabs">
                  <button
                    type="button"
                    className={`aq-legal-tab ${activeLegalTab === "refund" ? "is-active" : ""}`}
                    onClick={() => setActiveLegalTab("refund")}
                  >
                    {isAr ? "سياسة الاسترجاع" : "Refund Policy"}
                  </button>

                  <button
                    type="button"
                    className={`aq-legal-tab ${activeLegalTab === "terms" ? "is-active" : ""}`}
                    onClick={() => setActiveLegalTab("terms")}
                  >
                    {isAr ? "الشروط والأحكام" : "Terms & Conditions"}
                  </button>
                </div>
              </div>

              <div className="aq-legal-body">
                {activeLegal.sections.map((section, idx) => (
                  <div className="aq-legal-block" key={`legal-${idx}`}>
                    <h4>{section.heading}</h4>
                    <ul className="aq-list aq-legal-list">
                      {section.items.map((item, itemIdx) => (
                        <li key={`legal-item-${idx}-${itemIdx}`}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              <div className="aq-legal-cta">
                <button className="aq-btn aq-btn-solid aq-plan-btn" onClick={onDownload}>
                  {activeLegal.cta}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}